import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/Tenant/Documents";

import Images from "../../Assets/Images";

import "../../Styles/ProjectDocuments.scss";
import * as moment from "moment";

import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { formatDate } from "@telerik/kendo-intl";
import { Popup } from "@progress/kendo-react-popup";

class FetchDocument extends Component {
  constructor(props) {
    super(props);

    this.state = {
      skip: 0,
      take: 10,
      openDeleteModelFlag: false,
      currentRowId: 0,
    };
  }

  deleteProjectOpen = (row) => {
    var type = this.props.type;

    if (type == "projectdocs") {
      this.setState({
        openDeleteModelFlag: true,
        currentRowId: row.projectDocumentId,
      });
    } else if (type == "riskregisterdocs") {
      this.setState({
        openDeleteModelFlag: true,
        currentRowId: row.riskRegisterDocumentId,
      });
    } else if (type == "riskmitigationdocs") {
      this.setState({
        openDeleteModelFlag: true,
        currentRowId: row.riskRegisterActionDocumentId,
      });
    }else if (type == "taskregisterdocs") {
      this.setState({
        openDeleteModelFlag: true,
        currentRowId: row.taskRegisterDocumentId,
      });
    }else if (type == "taskactiondocs") {
      this.setState({
        openDeleteModelFlag: true,
        currentRowId: row.taskActionDocumentId,
      });
    } 
  };

  deleteProjectClose = () => {
    this.setState({ openDeleteModelFlag: false, currentRowId: 0 });
  };

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  pathFormatter(params) {
    var n = params.value.lastIndexOf("/");
    var res = params.value.substring(n + 1, params.value.length);
    return res;
  }
  dateFormatter(params) {
    return moment(params.value).format("DD-MM-YYYY");
  }

  async removeDocument() {
    if (this.state.currentRowId && this.state.currentRowId == 0) {
      return;
    }

    const { actions } = this.props;
    let params = {
      id: this.state.currentRowId,
      DocType: this.props.type,
    };
    await actions.deleteDocumentById(params);
    this.fetchDocumentData();
    this.deleteProjectClose();
  }

  fetchDocumentData() {
    const token =
        secureLocalStorage.getItem("loggedClient") == "user"
          ? secureLocalStorage.getItem("userKey")
          : secureLocalStorage.getItem("tenantKey");
const loggedClient=secureLocalStorage.getItem("loggedClient");
    // if (loggedClient && loggedClient == "tenant") {
      const { actions } = this.props;
      let params = {
        TenantKey: token,
        id: this.props.id,
        type: this.props.type,
      };
      actions.FetchDocumentData(params);
    // } else {
    //   this.props.history.push("/"+loggedClient+"/" + token + "/adddocuments");
    // }
  }

  componentDidMount() {
    this.fetchDocumentData();
  }

  render() {
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    let { documentFetchData } = this.props;
    const formatDateCellStartDate = (event) => {
      return (
        <td>
          {formatDate(
            new Date(event.dataItem.createdDate),
            "dd-MMM-yyyy :hh:mm:ss"
          )}
        </td>
      );
    };
    const actionButtons = (event) => {
      let eventData = event;

      let itemId = JSON.stringify(event.dataItem.id);
      debugger;

      return (
        <td>
          <ul className="actionIcon">
            <li>
              <a
                title="Delete"
                className="redbtn icon"
                onClick={() => this.deleteProjectOpen(event.dataItem)}
              >
                <img src={Images.DELETE} width="10" alt="Cancel" />
              </a>
            </li>
          </ul>
        </td>
      );
    };

    if (documentFetchData != undefined && documentFetchData.length > 0) {
      return (
        <div className=" dataGrids">
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this document?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeDocument()}
                  className="deleteBtn"
                >
                  Delete
                </button>
                <button onClick={this.deleteProjectClose} className="cancelBtn">
                  Cancel
                </button>
              </div>
            </div>
          </Popup>
          <Grid
            reorderable
            resizable
            data={documentFetchData.slice(
              this.state.skip,
              this.state.take + this.state.skip
            )}
            skip={this.state.skip}
            take={this.state.take}
            total={documentFetchData.length}
            pageable={true}
            onPageChange={this.pageChange}
          >
            {/* <Column field="projectDocumentId" title="ID" width="40px" /> */}
            {/* <Column field="projectId" title="Project Id" width="100px" /> */}
            <Column
              field="documentPath"
              title="FileName"
              cell={(props) => (
                <td>
                  <a href={props.dataItem.documentPath} target="_blank">
                    {props.dataItem.documentName
                      ? props.dataItem.documentName
                      : "NA"}
                  </a>
                </td>
              )}
            />
            <Column field="createdBy" title="Created By" />
            <Column
              field="createdDate"
              title="Created Date"
              cell={formatDateCellStartDate}
            />
            {/* <Column field="UploadUser" title="Upload User"  /> */}
            <Column cell={actionButtons} width="40px" />
          </Grid>
        </div>
      );
    } else {
      return <div>No Records Found ...!</div>;
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    documentFetchData: state.Documents.documentData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FetchDocument);
